import React from 'react';

import './style.css';
import './mobileStyles.css';
import { isMobile } from '../../helpers/utils';

const Header = props => {
    const { mainHeading, subHeading, subHeadingDesc, subHeadingPres, popUpHide } = props;

    return (
        <div className={isMobile() ? `comp-header mobile-comp-header mobile-font-family` : `comp-header-mainHeader`}>
            <div>
                <h1 className="bold" >
                    {mainHeading}
                </h1>
            </div>
            <div className="bold">
                {/* <h2 className={popUpHide ? `hide ` : `` + isMobile() ? `semi-bold` : `bold`}>
                    {subHeading}
                </h2> */}
                <p className="comp-header-subHeader-desc"> {subHeadingDesc}</p>
                <p className="comp-header-subHeader-desc-prescription italic" dangerouslySetInnerHTML={{ __html: subHeadingPres }}>

                </p>
            </div>
        </div>
    )
};

export default Header;
